import { useState } from "react";
import { DatePicker, Select, InputNumber, Button, Image, Form } from "antd";
import dayjs from "dayjs";
import "antd/dist/reset.css"; // reset antd styles
import hotelCategory from "../assets/images/bannerHotel.jpg";
import PriceRangeDropdown from "../components/PriceRangeDropdown.jsx";
import RoomsGuestsDropdown from "./RoomsGuestsDropdown.jsx";
import CustomDateRange from "./CustomDateRange.jsx";
import { useNavigate } from "react-router-dom";

const { RangePicker } = DatePicker;
const { Option } = Select;

export default function HotelSearchUI() {
  const [formData, setFormData] = useState({
    country: "UAE",
    city: "Dubai",
    checkIn: dayjs("2025-08-10"),
    checkOut: dayjs("2025-08-11"),
    rooms: 1,
    guests: 2,
    price: [2500, 5000],
  });
const navigate = useNavigate();
  return (
    <div className="relative min-h-[400px] bg-cover bg-center flex items-center justify-center">
      <div className="absolute z-10 inset-0 bg-black/45" />
      <Image
        preview={false}
        className="!w-screen !h-[400px]"
        src={hotelCategory}
      />
      {/* White Card */}
      <div className="container absolute -bottom-20 z-20 bg-white shadow-[0px_4px_6px_1px_rgba(0,0,0,0.25)] rounded-2xl p-8">
        {/* Heading */}
        <h2 className="text-2xl font-semibold mb-2">
          Hotels You <span className="text-danger">Love</span>, Prices You’ll{" "}
          <span className="text-primary">Adore</span>
        </h2>
        <p className="font-normal mt-1">
          Culture, nature, thrills, and record-breaking experiences
        </p>

        <Form
          layout="vertical"
          className="mt-8 grid grid-cols-6 gap-4 border rounded-md bg-white shadow-md px-4"
        >
          {/* Country */}
          <Form.Item
            name="country"
            label="Select Country"
            className="col-span-1 m-0 font-medium border-r py-4"
          >
            <Select
              defaultValue={formData.country}
              bordered={false}
              size="large"
              className="w-full custom-select text-primary"
            >
              <Option value="UAE">UAE</Option>
              <Option value="Thailand">Thailand</Option>
              <Option value="USA">USA</Option>
              <Option value="France">France</Option>
            </Select>
          </Form.Item>

          {/* City */}
          <Form.Item
            name="city"
            label="Select City"
            className="font-medium col-span-1 m-0 py-4 border-r"
          >
            <Select
              defaultValue={formData.city}
              bordered={false}
              size="large"
              className="w-full custom-select text-danger"
            >
              <Option value="Dubai">Dubai</Option>
              <Option value="Bangkok">Bangkok</Option>
              <Option value="New York">New York</Option>
              <Option value="Paris">Paris</Option>
            </Select>
          </Form.Item>

          {/* Check-In / Check-Out */}
          <Form.Item
            name="dateRange"
            className="col-span-2 m-0 font-medium py-4 border-r"
          >
            <CustomDateRange />
          </Form.Item>

          {/* Rooms & Guests */}
          <Form.Item
            label=""
            className="col-span-1 m-0 font-medium py-4 border-r"
          >
            <RoomsGuestsDropdown />
          </Form.Item>

          {/* Price Range Display */}
          <Form.Item
            label="Price Range"
            name="priceRange"
            className="col-span-1 m-0 font-medium py-4"
          >
            <PriceRangeDropdown
              value={formData.priceRange}
              onChange={(val) => console.log(val)}
            />
          </Form.Item>
        </Form>
        {/* Footer */}
        <div className="mt-6 text-sm font-medium text-black/60">
          <span className="font-semibold text-black">
            Most Searched & People’s Choice :{" "}
          </span>
          <span className="">Dubai, United Arab Emirates</span> |{" "}
          <span className="">Bangkok, Thailand</span> |{" "}
          <span className="">New York, United States</span> |{" "}
          <span className="">Paris, France</span>
        </div>
        {/* Button */}
        <div className="text-center mt-8 mb-[-55px]">
          <Button
            type="danger"
            size="middle"
            className="rounded-full px-14 py-7 shadow-md text-lg font-medium flex-1 
             bg-danger hover:bg-red-700 border-none 
             text-white w-fit"
             onClick={() => navigate('/hotel-detail')}
          >
            Search for Best Result sfsd
          </Button>
        </div>
      </div>
    </div>
  );
}
